export const hospitalTypes = {
    GET_HOSPITAL_PROFILE: "GET_HOSPITAL_PROFILE",
    CURRENT_HOSPITAL_NOT_FOUND: "CURRENT_HOSPITAL_NOT_FOUND",
    GET_HOSPITAL_DOCTORS: "GET_HOSPITAL_DOCTORS",
    SET_HOSPITAL_DOCTORS_SEARCH_DATA: "SET_HOSPITAL_DOCTORS_SEARCH_DATA",
    CLEAR_HOSPITAL_DOCTORS_SEARCH_DATA: "CLEAR_HOSPITAL_DOCTORS_SEARCH_DATA",
    CLEAR_HOSPITAL_DOCTORS_LIST: "CLEAR_HOSPITAL_DOCTORS_LIST",
    CLEAR_HOSPITAL_PROFILE: "CLEAR_HOSPITAL_PROFILE",
    FETCHING_MORE_HOSPITAL_DOCTORS: "FETCHING_MORE_HOSPITAL_DOCTORS",
    NO_MORE_HOSPITAL_DOCTORS: "NO_MORE_HOSPITAL_DOCTORS",
};